export default "__VITE_ASSET__67aaa0af__"